// Google OAuth Configuration
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '912573243985-9njoungfc59jvltr5674gb3lq3d1if3l.apps.googleusercontent.com';

// Initialize Google Identity Services
export const initializeGoogleAuth = () => {
  if (typeof window !== 'undefined' && window.google) {
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
      auto_select: false,
      cancel_on_tap_outside: true,
    });
  }
};

// Handle the credential response
const handleCredentialResponse = async (response) => {
  try {
    // Decode the JWT token
    const decoded = jwt_decode(response.credential);
    
    // Store the token and user info
    localStorage.setItem('google_token', response.credential);
    localStorage.setItem('google_user', JSON.stringify(decoded));
    
    // Trigger a custom event for the app to handle
    window.dispatchEvent(new CustomEvent('googleSignIn', {
      detail: { credential: response.credential, user: decoded }
    }));

  } catch (error) {
    console.error('Error handling Google sign-in:', error);
    window.dispatchEvent(new CustomEvent('googleSignInError', {
      detail: { error: error.message }
    }));
  }
};

// Render the Google Sign-In button
export const renderGoogleSignIn = (elementId, options = {}) => {
  if (typeof window !== 'undefined' && window.google && window.google.accounts) {
    try {
      // Clear any existing content
      const element = document.getElementById(elementId);
      if (element) {
        element.innerHTML = '';
      }
      
      window.google.accounts.id.renderButton(
        document.getElementById(elementId),
        {
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          shape: 'rectangular',
          width: '100%',
          ...options
        }
      );
    } catch (error) {
      console.error('Error rendering Google sign-in button:', error);
    }
  }
};

// Sign out from Google
export const signOutGoogle = () => {
  if (typeof window !== 'undefined' && window.google && window.google.accounts) {
    window.google.accounts.id.disableAutoSelect();
  }
  localStorage.removeItem('google_token');
  localStorage.removeItem('google_user');
  
  // Trigger sign-out event
  window.dispatchEvent(new CustomEvent('googleSignOut'));
};

// Check if user is signed in with Google
export const isGoogleSignedIn = () => {
  return !!localStorage.getItem('google_token');
};

// Get Google user info
export const getGoogleUser = () => {
  const userStr = localStorage.getItem('google_user');
  return userStr ? JSON.parse(userStr) : null;
};

// Get Google access token
export const getGoogleToken = () => {
  return localStorage.getItem('google_token');
};

// JWT Decode function (simple implementation)
const jwt_decode = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

// Load Google Identity Services script
export const loadGoogleScript = () => {
  if (typeof window !== 'undefined') {
    // Check if Google is already available
    if (window.google && window.google.accounts) {
      console.log('Google Identity Services already loaded');
      initializeGoogleAuth();
      return;
    }

    // Check if script is already being loaded
    if (document.querySelector('script[src*="accounts.google.com/gsi/client"]')) {
      // Wait for the script to load
      const waitForGoogle = () => {
        if (window.google && window.google.accounts) {
          console.log('Google Identity Services script loaded successfully');
          initializeGoogleAuth();
        } else {
          setTimeout(waitForGoogle, 100);
        }
      };
      waitForGoogle();
      return;
    }

    // If no script found, load it dynamically
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.type = 'text/javascript';
    
    script.onload = () => {
      console.log('Google Identity Services script loaded successfully');
      // Small delay to ensure Google is fully loaded
      setTimeout(() => {
        initializeGoogleAuth();
      }, 100);
    };
    
    script.onerror = (error) => {
      console.error('Failed to load Google Identity Services script:', error);
    };
    
    document.head.appendChild(script);
  }
};

// Don't auto-initialize - let the hook handle it 